import React from "react";

import PropTypes from "prop-types";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";

const DynamicTooltip = ({
  tooltipId,
  target,
  show,
  placement,
  tooltipMessage,
}) => (
  <Overlay target={target} show={show} placement={placement}>
    <Tooltip id={tooltipId}>{tooltipMessage}</Tooltip>
  </Overlay>
);

DynamicTooltip.propTypes = {
  placement: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  target: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
      ]),
    }),
  ]).isRequired,
  tooltipId: PropTypes.string.isRequired,
  tooltipMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default DynamicTooltip;
